import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';
import { MTOComponentOptionCompatibilityLineContainerModel } from '../../../../../../models/aggregates/erp/mto';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class MTOComponentOptionCompatibilityLineService extends BaseApiPublicLoginTemplateService<MTOComponentOptionCompatibilityLineContainerModel, MTOComponentOptionCompatibilityLineContainerModel, MTOComponentOptionCompatibilityLineContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-option-compatibility-lines';
  readonly endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-option-compatibility-lines/' + Core2Config.PUBLIC_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-option-compatibility-lines';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-option-compatibility-lines';
    this.httpClient = http;
  }
}